import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import { format } from "date-fns";
import SocialShare from '../../components/SocialShare';
import SimilarJobs from '../../components/SimilarJobs';
import JobConsultant from '../JobConsultant';
import { utcToZonedTime } from 'date-fns-tz';

export default function JobDetails({
    global,
    pathPrefix,
    customClass = "",
    post,
    buttonTitle,
    buttonLink,
    job_type,
    jobId,
    successPageUrl,
    content,
    share_job_content,
    similar_jobs,
    locale

}) {

    const toBold = text => {
        const charSet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '!', '?', '.', ',', '"', "'"];
        const targetCharSet = ['𝗮', '𝗯', '𝗰', '𝗱', '𝗲', '𝗳', '𝗴', '𝗵', '𝗶', '𝗷', '𝗸', '𝗹', '𝗺', '𝗻', '𝗼', '𝗽', '𝗾', '𝗿', '𝘀', '𝘁', '𝘂', '𝘃', '𝘄', '𝘅', '𝘆', '𝘇', '𝗔', '𝗕', '𝗖', '𝗗', '𝗘',
            '𝗙', '𝗚', '𝗛', '𝗜', '𝗝', '𝗞', '𝗟', '𝗠', '𝗡', '𝗢', '𝗣', '𝗤', '𝗥', '𝗦', '𝗧', '𝗨', '𝗩', '𝗪', '𝗫', '𝗬', '𝗭', '𝟬', '𝟭', '𝟮', '𝟯', '𝟰', '𝟱', '𝟲', '𝟳', '𝟴', '𝟵', '❗', '❓', '.', ', ', '"', "'"]; const textArray = text.split('');
        let boldText = '';
        textArray.forEach((letter) => {
            const index = charSet.findIndex((_letter) => _letter === letter);
            if (index !== -1) {
                boldText = boldText + targetCharSet[index];
            } else {
                boldText = boldText + letter;
            }
        });
        return boldText;
    }
    const country = post.location.split(",")[0];
    const region = post.location.split(",")[1];
    const body =
        `Hi` + `\n\n` +
        `Bartech Staffing is hiring for the following opportunity:` + `\n\n` +
        toBold(post.title) + ` - ` + toBold(post.location) + ' \n\n'

    return (
        <section className={`${styles.root} ${customClass}`} >
            <Container>
                <Link href={`${buttonLink}`}>
                    <a className="text-white arrow-left d-flex align-items-center">
                        <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                            {buttonTitle}
                        </SourceFlowText>
                    </a>
                </Link>
                <Row className="mt-4">
                    <Col md={8} className="mb-4 mb-md-0">
                        <div className="rounded-4 overflow-hidden">
                            <div className="job-details p-4">
                                <h1 className="mb-4">{post?.title}</h1>
                                <Row className='mb-4'>
                                    {job_type ?
                                        <Col md={4} className="mb-2">
                                            <div className="d-flex flex-wrap">
                                                <div className="w-100 job-detail">
                                                    Job Type
                                                </div>
                                                <div>
                                                    {job_type}
                                                </div>
                                            </div>
                                        </Col>
                                        : null
                                    }
                                    {post?.location ?
                                        <Col md={4} className="mb-2">
                                            <div className="d-flex flex-wrap">
                                                <div className="w-100 job-detail">
                                                    Location
                                                </div>
                                                <div>
                                                    {post?.location}
                                                </div>
                                            </div>
                                        </Col> : ""}
                                    {post?.salary_package ?
                                        <Col md={4} className="mb-2">
                                            <div className="d-flex flex-wrap">
                                                <div className="w-100 job-detail">
                                                    Salary
                                                </div>
                                                <div>
                                                    {post?.salary_package === "Up to CA$0.00 per hour" ? "Competitive" : post?.salary_package}
                                                </div>
                                            </div>
                                        </Col> : null}
                                    {post?.external_reference ?
                                        <Col md={4} className="mb-2">
                                            <div className="d-flex flex-wrap">
                                                <div className="w-100 job-detail">
                                                    Job Ref
                                                </div>
                                                <div>
                                                    {post?.external_reference}
                                                </div>
                                            </div>
                                        </Col>
                                        : null
                                    }
                                    {post?.created_at ?
                                        <Col md={4} className="mb-2">
                                            <div className="d-flex flex-wrap">
                                                <div className="w-100 job-detail">
                                                    Date Added
                                                </div>
                                                <div>
                                                    {/* {format(new Date(post?.created_at), 'LLLL do, Y')} */}
                                                    {/* {new Date(post?.created_at).toLocaleDateString('en-US', { timeZone: 'UTC' })} */}
                                                    {format(utcToZonedTime(new Date(post?.created_at), 'UTC'), 'LLLL do, Y')}
                                                </div>
                                            </div>
                                        </Col>
                                        : null
                                    }


                                </Row>
                            </div>
                            {post?.description ?
                                <div className="job-description p-4" dangerouslySetInnerHTML={{ __html: post?.description }} />
                                : null}
                            <SimilarJobs
                                global={global}
                                pathPrefix={'job_page.similar_jobs'}
                                customClass="px-4 pt-5 pb-4"
                                content={
                                    <>
                                        <h2>Similar Jobs</h2>
                                    </>
                                }
                                buttonTitle={`View all Jobs`}
                                buttonLink={`/${locale ? `${locale}/` : ""}jobs/`}
                                post={similar_jobs}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="rounded-4 overflow-hidden">
                            <div className="p-4 yellow-bg">
                                {content ?
                                    <div className="mb-4">
                                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                            {content}
                                        </SourceFlowText>
                                    </div>
                                    : null}
                                <SourceFlowApplicationForm onSubmitDone={() => window.location.href = successPageUrl} jobId={jobId} />
                            </div>
                            <div className="p-4 border bg-white rounded-bottom-4">
                                <JobConsultant
                                    global={global}
                                    pathPrefix={pathPrefix}
                                    customClass="job-consultant"
                                    jobId={post.id}
                                    heading={
                                        <>
                                            <p><strong>Contact Consultant</strong></p>
                                        </>
                                    }
                                />
                                <hr></hr>
                                {share_job_content ?
                                    <div className="mb-2 text-center">
                                        <SourceFlowText global={global} path={`${pathPrefix}.share_job_content`} type="html">
                                            {share_job_content}
                                        </SourceFlowText>
                                    </div>
                                    : null}
                                <SocialShare
                                    customClass="jobs-page-social-share justify-content-center d-flex mb-4"
                                    post={post}
                                    body={body}
                                    twitter={true}
                                    facebook={true}
                                    linkedin={true}
                                    email={true}
                                    whatsapp={true}
                                    urlPrefix={`jobs`}
                                    twitterText={`Share on Twitter`}
                                    facebookText={`Share on Facebook`}
                                    linkedinText={`Share on LinkedIn`}
                                    LinkCopy={`Copy Link`}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}